import * as EventListener from "../helpers/event-listener";

const clickByLatter = () => {
    EventListener.click("letter-button", (button) => {
        if (button.classList.contains("active")) {
            button.classList.remove("active");
        } else {
            button.classList.add("active");
        }

        document.getElementById("searchLetter").value = "";

        document.querySelectorAll(".region-item").forEach((element) => {
            element.style.display = "block";
        });

        document
            .querySelectorAll(".region-container .region-item")
            .forEach((element) => {
                element.style.display = "none";
            });

        document.querySelector(".information-block").style.display = "none";

        const activeElements = document.querySelectorAll(
            ".letter-button.active",
        );

        activeElements.forEach((element) => {
            const letter = element.getAttribute("data-letter");

            document
                .querySelectorAll(`.region-container [data-letter=${letter}]`)
                .forEach((element) => {
                    element.style.display = "block";
                });
        });

        if (!activeElements.length) {
            document.querySelectorAll(".region-item").forEach((element) => {
                element.style.display = "block";
            });
        }

        button.disabled = false;
    });
};

const search = () => {
    EventListener.input("searchLetter", (input) => {
        const search = input.value.trim().toLowerCase();

        document.querySelectorAll(".region-item").forEach((element) => {
            element.style.display = "block";
        });

        document.querySelectorAll(".region-container a").forEach((element) => {
            element.style.display = "block";
        });

        document.querySelector(".information-block").style.display = "none";

        if (!search) {
            return;
        }

        document
            .querySelectorAll(".letter-button.active")
            .forEach((element) => {
                element.classList.remove("active");
            });

        const letter = search.charAt(0);

        document
            .querySelectorAll(".region-container .region-item")
            .forEach((element) => {
                element.style.display = "none";
            });

        document
            .querySelectorAll(`.region-container [data-letter=${letter}]`)
            .forEach((element) => {
                element.style.display = "block";
            });

        const elements = document.querySelectorAll(
            `.region-container [data-letter=${letter}] a`,
        );
        let numberOfHiddenElements = 0;

        elements.forEach((element) => {
            if (!element.innerHTML.toLowerCase().match(search)) {
                numberOfHiddenElements++;
                element.style.display = "none";
            }
        });

        if (numberOfHiddenElements === elements.length) {
            if (elements[0]) {
                elements[0].closest(".region-item").style.display = "none";
            }

            document.querySelector(".information-block").style.display = "flex";
        }
    });
};

clickByLatter();
search();
